import {
  MAP_CANDIDATE,
  MAP_CANDIDATE_SUCCESS,
  MAP_CANDIDATE_FAIL,
  GET_MAPPED_CANDIDATE_DETAILS,
  GET_MAPPED_CANDIDATE_DETAILS_SUCCESS,
  GET_MAPPED_CANDIDATE_DETAILS_FAIL,
  GET_MAPPED_CANDIDATES,
  GET_MAPPED_CANDIDATES_SUCCESS,
  GET_MAPPED_CANDIDATES_FAIL,
  GET_MAPPED_CANDIDATES_COUNT,
  GET_MAPPED_CANDIDATES_COUNT_SUCCESS,
  GET_MAPPED_CANDIDATES_COUNT_FAIL,
  GET_CANDIDATE_STATUS,
  GET_CANDIDATE_STATUS_SUCCESS,
  GET_CANDIDATE_STATUS_FAIL,
  GET_CANDIDATE_ACTIVITY_FEED,
  GET_CANDIDATE_ACTIVITY_FEED_SUCCESS,
  GET_CANDIDATE_ACTIVITY_FEED_FAIL,
} from "./actionTypes";

const initialState = {
  errorMessage: null,
  successMessage: null,
  loader: false,
  mappedCandidateDetails: {},
  mappedCandidates: {},
  mappedCandidatesCount: {},
  currentStatus: null,
  currentStatusFailed: null,
  candidateActivityFeed: [],
};

const mappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case MAP_CANDIDATE:
      state = {
        ...state,
        loader: true,
        errorMessage: null,
        successMessage: null,
      };
      break;
    case MAP_CANDIDATE_SUCCESS:
      state = {
        ...state,
        loader: false,
        successMessage: action.payload,
      };
      break;
    case MAP_CANDIDATE_FAIL:
      state = {
        ...state,
        loader: false,
        errorMessage: action.payload,
      };
      break;
    case GET_MAPPED_CANDIDATE_DETAILS:
      state = {
        ...state,
        loader: true,
        mappedCandidateDetails: null,
        errorMessage: null,
      };
      break;
    case GET_MAPPED_CANDIDATE_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        mappedCandidateDetails: action.payload,
      };
      break;
    case GET_MAPPED_CANDIDATE_DETAILS_FAIL:
      state = {
        ...state,
        loader: false,
        mappedCandidateDetails: null,
        errorMessage: action.payload,
      };
      break;
    case GET_MAPPED_CANDIDATES:
      state = {
        ...state,
        loader: true,
        successMessage: null,
        errorMessage: null,
      };
      break;
    case GET_MAPPED_CANDIDATES_SUCCESS:
      state = {
        ...state,
        loader: false,
        mappedCandidates: action.payload,
      };
      break;
    case GET_MAPPED_CANDIDATES_FAIL:
      state = {
        ...state,
        loader: false,
        mappedCandidates: null,
        errorMessage: action.payload,
      };
      break;
    case GET_MAPPED_CANDIDATES_COUNT:
      state = {
        ...state,
        loader: true,
        mappedCandidatesCount: null,
        errorMessage: null,
      };
      break;
    case GET_MAPPED_CANDIDATES_COUNT_SUCCESS:
      state = {
        ...state,
        loader: false,
        mappedCandidatesCount: action.payload,
        errorMessage: null,
      };
      break;
    case GET_MAPPED_CANDIDATES_COUNT_FAIL:
      state = {
        ...state,
        loader: false,
        mappedCandidatesCount: null,
        errorMessage: action.payload,
      };
      break;
    case GET_CANDIDATE_STATUS:
      state = {
        ...state,
        loader: false,
        currentStatus: null,
        currentStatusFailed: null,
      };
      break;
    case GET_CANDIDATE_STATUS_SUCCESS:
      state = {
        ...state,
        loader: false,
        currentStatus: action.payload,
        currentStatusFailed: null,
      };
      break;
    case GET_CANDIDATE_STATUS_FAIL:
      state = {
        ...state,
        loader: false,
        currentStatus: null,
        currentStatusFailed: action.payload,
      };
      break;

    case GET_CANDIDATE_ACTIVITY_FEED:
      state = {
        ...state,
        candidateActivityFeed: [],
      };
      break;
    case GET_CANDIDATE_ACTIVITY_FEED_SUCCESS:
      state = {
        ...state,
        candidateActivityFeed: action.payload,
      };
      break;
    case GET_CANDIDATE_ACTIVITY_FEED_FAIL:
      state = {
        ...state,
        candidateActivityFeed: [],
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default mappingReducer;
